<template>
    <div class="general">
        <div class="inspection inspection-mobile">
            <div class="d-flex align-center">
                <h2>Осмотр</h2>
                <div class="ml-2 pt-1">
                    <v-tooltip top content-class="custom-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                            <svg v-bind="attrs" v-on="on" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <rect y="0.5" width="24" height="24" rx="12" fill="#CACDD3"/>
                                <path d="M10.873 14.9972V14.8892C10.8806 14.1847 10.9507 13.6241 11.0833 13.2074C11.2196 12.7908 11.4128 12.4536 11.6628 12.1961C11.9128 11.9385 12.214 11.7036 12.5662 11.4915C12.7935 11.3476 12.998 11.1866 13.1799 11.0086C13.3617 10.8305 13.5056 10.626 13.6117 10.3949C13.7177 10.1639 13.7708 9.90819 13.7708 9.62789C13.7708 9.29076 13.6912 8.9991 13.5321 8.75289C13.373 8.50667 13.1609 8.31728 12.8958 8.1847C12.6344 8.04834 12.3427 7.98016 12.0208 7.98016C11.7291 7.98016 11.4507 8.04076 11.1855 8.16198C10.9204 8.28319 10.7007 8.47258 10.5265 8.73016C10.3522 8.98395 10.2518 9.3116 10.2253 9.71311H8.49805C8.52456 9.03129 8.69691 8.45554 9.01509 7.98584C9.33327 7.51236 9.75373 7.1544 10.2765 6.91198C10.803 6.66955 11.3844 6.54834 12.0208 6.54834C12.7177 6.54834 13.3276 6.67902 13.8503 6.94039C14.373 7.19796 14.7784 7.5597 15.0662 8.02561C15.3579 8.48773 15.5037 9.02751 15.5037 9.64493C15.5037 10.0692 15.4374 10.4517 15.3049 10.7927C15.1723 11.1298 14.9829 11.4309 14.7367 11.6961C14.4943 11.9612 14.2026 12.1961 13.8617 12.4006C13.5397 12.6014 13.2783 12.8097 13.0776 13.0256C12.8806 13.2415 12.7367 13.4972 12.6458 13.7927C12.5549 14.0881 12.5056 14.4536 12.498 14.8892V14.9972H10.873ZM11.731 18.4517C11.4204 18.4517 11.1533 18.3419 10.9299 18.1222C10.7064 17.8987 10.5946 17.6298 10.5946 17.3154C10.5946 17.0048 10.7064 16.7396 10.9299 16.5199C11.1533 16.2964 11.4204 16.1847 11.731 16.1847C12.0378 16.1847 12.303 16.2964 12.5265 16.5199C12.7537 16.7396 12.8674 17.0048 12.8674 17.3154C12.8674 17.5237 12.8143 17.715 12.7083 17.8892C12.606 18.0597 12.4696 18.1961 12.2992 18.2983C12.1287 18.4006 11.9393 18.4517 11.731 18.4517Z" fill="white"/>
                            </svg>
                        </template>
                        <div class="info-tooltip">Отметьте патологию <br> одиночным кликом по <br> тексту </div>
                    </v-tooltip>
                </div>
            </div>
            <div class="inspection-header">
                <h3>Выберите систему организма, проведите осмотр пациента и отметьте патологию:</h3>
                <div class="header-icons">
                    <div
                        class="preloader"
                        v-for="(el, ind) in getGeneral.iconsList"
                        :key="'C'+ind"
                    >
                        <div
                            class="icon"
                            :class="{
                                'active': nameSystemClick.nameLong === el.nameLong,
                                'disableEL': bodySystemDisabled(el.id),
                                'clickEl': false
                            }"
                            @click.prevent="disabled || bodySystemDisabled(el.id) ? '' : clickSystemFilter(el, 'nameSystemClick')"
                            :title="el.nameLong"
                        >
                            <inline-svg :src="require(`@/assets/SystemMini/${el.icon}`)" />
                            {{ el.name }}
                        </div>

                        <v-overlay :value="el.loading || loadAll" absolute>
                            <v-progress-circular indeterminate size="30" />
                        </v-overlay>
                    </div>
                </div>
            </div>
            <div class="inspection-body">
                <div class="body-left">
                    <div class="body-item">
                        <h3 v-if="!loadAll">{{ nameSystemClick.nameLong }}</h3>

                        <v-skeleton-loader
                            v-for="item in 4"
                            :key="item"
                            v-show="loadAll || loadSystem || (!getSprPhysResearchAll.groups && disabled)"
                            type="list-item-three-line"
                        />

                        <div v-for="(item, key) in getSprPhysResearchAll.groups" :key="'a'+key" v-show="getSprPhysResearchAll.groups && !loadAll && !loadSystem">
                            <h4 class="mb-2">{{item.groupName }}</h4>
                            <p
                                v-for="(it, ind) in item.indicators"
                                :key="'B'+ind"
                                class="list-p"
                                :class="{'selected': it.isPathology }"
                                @click="selectedPatalogy(it)"
                            >
                                <span v-if="it.valueType === 1">
                                    {{ it.propertyName }}: {{ it.listValueName }}
                                </span>
                                <span v-if="it.valueType === 0">
                                    {{ it.propertyName }}: {{ it.avgValue }} {{ it.measurementName }}
                                </span>
                            </p>
                        </div>

                        <div v-show="getSprPhysResearchAll.groups && localStatusSystem && !loadAll && !loadSystem">
                            <h4 class="mb-2">Локальный статус</h4>
                            <p>
                                <span>{{ localStatusSystem }}</span>
                            </p>
                        </div>

                        <p v-if="nameSystemClick.id && getSprPhysResearchAll.groups === 0 && !disabled" class="list-p">Данных нет...</p>
                    </div>
                </div>
                <div class="body-right">
                    <div class="img-wrap">
                        <skin-human />
                    </div>
                </div>
            </div>
        </div>

        <div class="button d-flex justify-end mt-8">
            <slot name="btn" />
        </div>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import InlineSvg from 'vue-inline-svg';
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import skinHuman from '../Human/skin.vue';

export default {
    name: 'inspection',
    components: {
        InlineSvg,
        TimeoutSnackbar,
        skinHuman
    },
    computed: {
        ...mapGetters({
            apiGuide: 'apiGuide',
            getGeneral: 'takeDiagnosticTest/getGeneral',
            getDataSomaticStatusBodySystems: 'takeDiagnosticTest/getDataSomaticStatusBodySystems',
            getSprPhysResearchAll: 'takeDiagnosticTest/getSprPhysResearch',
            getFirstStepOrNot: 'takeDiagnosticTest/getFirstStepOrNot'
        })
    },
    data() {
        return {
            localStatusSystem: null,
            loadAll: true,
            loadSystem: false,
            disabled: false,
            selectedPropertyObject: {
                groupName: '',
                propertyName: '',
                viewImage: true
            },
            snackbar: {
                show: false,
                text: null,
                color: null,
                timeout: -1
            },
            rules: {
                required: (v, text) => (!!v || v === 0) || (text ? text : 'Обязательно для заполнения.'),
                minMax: (v, min, max) => v >= min && v <= max || 'Референс не соблюден!.'
            },
            nameSystemClick: {
                nameLong: 'Выберите систему...'
            },
            showImg: false
        }
    },
    methods: {
        ...mapActions({
            getSprPhysResearch: 'takeDiagnosticTest/getSprPhysResearch',
            getAllSprBodySystem: 'takeDiagnosticTest/getAllSprBodySystem',
            getSomaticStatusBodySystems: 'takeDiagnosticTest/getSomaticStatusBodySystems',
            getSomaticStatusesByTestId: 'takeDiagnosticTest/getSomaticStatusesByTestId',
            getMediaFilesByBodySystemId: 'takeDiagnosticTest/getMediaFilesByBodySystemId',
            sendSomaticStatuseAnswer: 'takeDiagnosticTest/sendSomaticStatuseAnswer',
            getSections: 'takeDiagnosticTest/getSections'
        }),
        ...mapMutations({
            changeFlagMissingStep: 'takeDiagnosticTest/changeFlagMissingStep',
            saveSelectedProperty: 'takeDiagnosticTest/saveSelectedProperty',
            resetFiles: 'takeDiagnosticTest/resetFiles',
            changeViewPage: 'takeDiagnosticTest/changeViewPage',
            checkingFirstStep: 'takeDiagnosticTest/checkingFirstStep'
        }),
        clickSystemFilter(obj, nameVariables) {
            this.sortArray(this.getSprPhysResearchAll.groups, 'groupSortOrder')
            if(this[nameVariables].nameLong === obj.nameLong) {
                return;
            }

            this.loadSystem = true;
            this.localStatusSystem = obj.localStatus;
            this[nameVariables] = obj
            this.disabled = true;
            obj.loading = true;
            this.resetFiles();

            this.getMediaFilesByBodySystemId({ testId: this.$route.query.diaTestId, bodySystemId: obj.id, type: 1 })
                .then(() => {
                    this.getSomaticStatusesByTestId({ processId: this.$route.params.id, bodySystemId: obj.id, physResearchId: this.getSprPhysResearchAll.currentObj.id })
                        .then((res) => {
                            obj.loading = false;
                            this.loadSystem = false;
                            this.disabled = false;
                        })
                })
        },
        bodySystemDisabled(id) {
            return this.getDataSomaticStatusBodySystems.find(x => x.bodySystemId === id) === undefined;
        },
        sortArray(array, name){
            // console.log(array);
            return array.sort((prev, next) => {
                const nameA = typeof prev[name] === 'string' ? prev[name].toUpperCase() : prev[name];
                const nameB = typeof next[name] === 'string' ? next[name].toUpperCase() : next[name];

                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            })
        },
        selectedPatalogy(item) {
            item.isPathology = !item.isPathology

            this.sendSomaticStatuseAnswer({ processId: this.$route.params.id, answerSomaticStatuseId: item.id, isPathology: item.isPathology })
        }
    },
    created() {
        this.getSections(this.$route.query.diaTestId)
            .then(() => {
                this.changeViewPage('Осмотр');
                this.checkingFirstStep();

                if(this.getFirstStepOrNot) {
                    this.introJS.setOptions({
                        steps: [
                            {
                                element: document.querySelector('.intro-info'),
                                intro: 'Обратите внимание на показатели пациента!',
                                position: 'bottom'
                            }
                        ]
                    }).start();
                }
            });
        this.resetFiles();
        this.getSprPhysResearch('Осмотр')
            .then(() => {
                this.getSomaticStatusBodySystems({ testId: this.$route.query.diaTestId, physResearchId: this.getSprPhysResearchAll.currentObj.id });

                this.getAllSprBodySystem()
                    .then(() => {
                        this.loadAll = false;
                    });
            });
    }
}
</script>

<style>
    .v-tooltip__content.menuable__content__active, .custom-tooltip {
        background: #717BF9 !important;
        opacity: 1 !important;
    }
</style>
<style scoped>
    .info-tooltip  {
        width: 172px;
        height: 80px;
        padding: 8px;
        gap: 10px;
    }
    @media screen and (max-width: 500px) {
        .inspection {
            display: none;
        }
    }

    @media screen and (min-width: 501px) {
        .inspection-mobile{
            display: none;
        }
    }
</style>